"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTabWidgetDataSchema = exports.ProductTabItemSchema = exports.ProductTabDetailItemSchema = exports.WidgetCuratedProductGridLogMetaDto = exports.WidgetCuratedProductGridTabLogMetaDto = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.WidgetCuratedProductGridTabLogMetaDto = zod_1.z.object({
    object: zod_1.z.string(),
    objectType: common_1.EnClientLogObjectType,
    widgetTabPosition: zod_1.z.number(),
    widgetTabTitle: zod_1.z.string().nullable(),
});
exports.WidgetCuratedProductGridLogMetaDto = common_1.WidgetLogMeta.extend({
    object: zod_1.z.string(),
    objectType: zod_1.z.string(),
    deusGroupId: zod_1.z.string().nullable(),
    widgetPosition: zod_1.z.number(),
});
exports.ProductTabDetailItemSchema = zod_1.z.object({
    action: common_1.CommonResponseItemActionDto,
    availableQuantity: common_1.CommonResponseItemBenefitDto.nullable(),
    badges: zod_1.z.array(zod_1.z.nullable(common_1.CommonResponseItemPropertyDto)),
    benefits: zod_1.z.array(zod_1.z.nullable(common_1.CommonResponseItemBenefitDto)),
    caption: zod_1.z.nullable(common_1.CommonResponseItemCaptionDto),
    description: zod_1.z.nullable(common_1.CommonResponseItemPropertyDto),
    discountBadge: zod_1.z.nullable(common_1.CommonResponseItemPropertyDto),
    features: zod_1.z.array(zod_1.z.nullable(common_1.CommonResponseItemPropertyDto)),
    id: zod_1.z.string(),
    image: common_1.CommonResponseItemImageDto,
    location: common_1.CommonResponseItemPropertyDto.nullable(),
    locationDescription: zod_1.z.nullable(common_1.CommonResponseItemPropertyDto),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
    memberClassBadge: common_1.CommonResponseItemPropertyDto.nullable(),
    notices: zod_1.z.array(common_1.CommonResponseItemBenefitDto),
    position: zod_1.z.object({
        latitude: zod_1.z.number(),
        longitude: zod_1.z.number(),
    }),
    prices: zod_1.z.array(zod_1.z.array(common_1.CommonResponseItemPropertyDto)),
    ranking: zod_1.z.nullable(common_1.CommonResponseItemPropertyDto),
    review: zod_1.z.nullable(common_1.CommonResponseItemReviewDto),
    title: common_1.CommonResponseItemPropertyDto,
});
exports.ProductTabItemSchema = zod_1.z.object({
    header: zod_1.z
        .object({
        icon: zod_1.z.string().optional(),
        subTitle: zod_1.z.string().optional(),
        title: zod_1.z.string().optional(),
        more: common_1.WidgetMoreSchema.optional(),
    })
        .nullish(),
    items: zod_1.z.array(exports.ProductTabDetailItemSchema),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
});
/**
 * 상품형 탭 위젯 응답 스키마
 * 큐레이션 상품 - grid 타입 (YDM__NOL_CURATED_PRODUCT_GRID__V1)
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/CXT/pages/447563422/YDM__NOL_CURATED_PRODUCT_GRID__V1+-+grid+9.0.0~}
 */
exports.ProductTabWidgetDataSchema = zod_1.z.object({
    header: zod_1.z
        .object({
        icon: zod_1.z.string().optional(),
        subTitle: zod_1.z.string().optional(),
        title: zod_1.z.string(),
        more: common_1.WidgetMoreSchema.optional(),
    })
        .nullish(),
    items: zod_1.z.array(exports.ProductTabItemSchema),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
});
